import React from 'react'
import { Icon, Image, List, Segment } from 'semantic-ui-react'
import { uniqueKey } from '../../common/keys'
import { gEnums } from '../../enums/globalEnums'

const ImageList = ({ listItems, selectedItem, _imageProps, parentItems, noSize, storageType, oc }) => {

  const _imageSize = _imageProps?.appUser?.imageSize ? _imageProps.appUser.imageSize : 'small'

  const getSource = (f) => {
    try {
      const src = URL.createObjectURL(f)
      return src
    } catch (error) {
      return f
    }
  }

  const result = parentItems ? _.filter(parentItems, (obj) => _.has(obj, 'fileImage')) : null;

  const image = (keyy, src) => <Image key={keyy} size={noSize ? null : _imageSize} src={src} alt={'imageEdit'}></Image>

  const folderList = () => {
    const items = listItems ? listItems.map((item, index) => {
      const { name, fileImage } = item
      let fileContent;
      switch (storageType) {
        case gEnums.storageTypes.pdf:
          fileContent = <Icon name='file pdf outline' size='huge' />
          break
        default:
          fileContent = fileImage && image(uniqueKey('fli', index), getSource(fileImage))
      }

      const _result = result ? _.find(result, (obj) => obj?.name === name) : null;

      return <div key={uniqueKey('fl', index)} onClick={() => { selectedItem && oc(item) }} className={_result ? 'sel' : null}>
        <div>
          <div>{name}</div>
          {_result && <div>{_result.name}</div>}
        </div>
        <div>{fileContent}</div>
      </div>
    }) : []
    return <div className='image-list-list'>{items}</div>
  }

  return folderList()

}

export default ImageList